import { jsx as r } from "react/jsx-runtime";
import { tv as m } from "../tailwind-variants.config.js";
const s = m({
  base: "jm-flex jm-items-center jm-justify-center",
  variants: {
    size: {
      condensed: "jm-w-4 jm-h-4",
      regular: "jm-w-6 jm-h-6",
      large: "jm-w-6 jm-h-6"
    }
  },
  defaultVariants: {
    size: "regular"
  }
}), j = ({ icon: e, size: t }) => /* @__PURE__ */ r("span", { className: s({ size: t }), children: e });
export {
  j as ButtonIcon
};
//# sourceMappingURL=ButtonIcon.js.map
